import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import logo from '@/assets/logo.png';
export default function Landing() {
  return <div className="min-h-screen bg-background flex flex-col">
      {/* Header */}
      <header className="w-full px-6 py-4 flex items-center justify-between border-b border-border/50">
        <div className="flex items-center gap-3">
          <img src={logo} alt="Scalemage" className="h-8 w-8" />
          <span className="text-xl font-semibold text-foreground">Scalemage</span>
        </div>
        <Link to="/auth">
          <Button variant="outline" size="sm">Sign In</Button>
        </Link>
      </header>

      {/* Hero */}
      <main className="flex-1 flex flex-col items-center justify-center px-6 text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight max-w-3xl">
          <span className="bg-gradient-to-r from-primary via-emerald-400 to-primary bg-clip-text text-transparent">
            Instantly Adapt Images
          </span>
          <br />
          <span className="text-foreground">to Ads Formats</span>
        </h1>
        
        <p className="mt-6 text-lg md:text-xl text-muted-foreground max-w-2xl">
          Transform your visuals between Square, Portrait, and Horizontal formats with AI precision. 
          <span className="text-foreground font-medium"> Fast. Affordable. Perfect every time.</span>
        </p>

        <Link to="/auth?mode=signup" className="mt-10">
          <Button size="lg" className="text-lg px-8 py-6 bg-primary hover:bg-primary/90 shadow-[0_0_30px_rgba(16,185,129,0.3)] hover:shadow-[0_0_40px_rgba(16,185,129,0.4)] transition-all">
            Try Free — 3 Credits
          </Button>
        </Link>

        <p className="mt-4 text-sm text-muted-foreground">
          No credit card required
        </p>
      </main>

      {/* Footer */}
      <footer className="py-6 text-center text-sm text-muted-foreground border-t border-border/50">
        © {new Date().getFullYear()} Scalemage. All rights reserved.
      </footer>
    </div>;
}